class Constants {
    static get cacheKeys() {
        return {
            orderId: 'orderId',
            customerType: 'customerType',
            cookieConsent: 'cookieConsent',
            upgradeCheck: 'upgradeCheck',
        };
    }

    static get eventKeys() {
        return {
            modalContentRetrieved: 'modalContentRetrieved',
            modalContentSelected: 'modalContentSelected',
            bootstrapBreakpointChanged: 'bootstrapBreakpointChanged',
            upgradeStatusChanged: 'upgradeStatusChanged',
            deviceDetailsPriceInvalid: 'deviceDetailsPriceInvalid',
            deviceDetailsPriceChanged: 'deviceDetailsPriceChanged',
            eirModalToggled: 'eirModalToggled',
            cartContentChanged: 'cartContentChanged',
            modalHideRetrieved: 'modalHideRetrieved',
            cartSubscriberAdded: 'cartSubscriberAdded',
            updatedCartDetails: 'updatedCartDetails',
        };
    }

    static get externalCss() {
        return {
            slickCarousel: {
                minified:
                    'https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.8.1/slick.min.css',
                themeMinified:
                    'https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.8.1/slick-theme.min.css',
            },
        };
    }

    static get planTypes() {
        return {
            mobile: 'MOBILE',
            broadband: 'BROADBAND',
            voice: 'VOICE',
            tv: 'TV',
        };
    }

    static get siteTheme() {
        // to get the site theme color, secondary theme and headerlogo for all the sites ----
        var getSiteTheme, getTopNavTheme , getNavRightBorder, getSiteHeaderLogo  = ""; 
        for (let i = 0; i < window.components.length; i++) {
            if (window.components[i].type == "eir-header" && window.components[i].cmsContent.siteTheme != '') {     
                getSiteTheme= window.components[i].cmsContent.siteTheme;
                getTopNavTheme = window.components[i].cmsContent.topNavTheme;
                getNavRightBorder = window.components[i].cmsContent.navDDRtBorderColor;
                getSiteHeaderLogo = window.components[i].cmsContent.siteHeaderLogo;
                break;
            }
        }
        return { 
            primaryTheme:getSiteTheme,
            topNavTheme:getTopNavTheme,
            navRightBorder:getNavRightBorder,
            siteHeaderLogo:getSiteHeaderLogo
        };
        
    }
}

export default Constants;

// This is for Largebusiness project. 
 const lbHostNames = ["eirbusiness", "eirevo"]
//  const lbHostNames = ["eirbusiness", "eirevo", "localhost", "/busines/lb"] //For testing in local
export const LargeBusiness = ( 
    {
    isLBSite: lbHostNames.map((hostname)=>window.location.href.indexOf(hostname) > 0).includes(true),
    primaryColor: () => {
        let headerComponent =  window.components.filter(component => component.type==="eir-header");
        console.log(headerComponent)
    },
    is404: window.location.href.indexOf('404') > 0,
    is500: window.location.href.indexOf('500') > 0,
})

 
//Returns Margin Class name.
export const moduleMargins = (mDT, mMbl) => {
    let marginDesktop, marginMobile;
    switch (mDT) {
        case ("Top-60px,Bot-0px"): {
            marginDesktop = " marginT-60 ";
            break;
        }
        case ("Top-0px,Bot-60px"): {
            marginDesktop = " marginB-60 ";
            break;
        }
        case ("Top-60px,Bot-60px"): {
            marginDesktop = " margin-60 ";
            break;
        }
        case ("Top-0px,Bot-0px"): {
            marginDesktop = " margin-0-D ";
            break;
        }
        default: {
            marginDesktop = " marginT-60 ";
            break;
        }
    }
    switch (mMbl) {
        case ("Top-40px,Bot-0px"): {
            marginMobile = " marginT-40 ";
            break;
        }
        case ("Top-0px,Bot-40px"): {
            marginMobile = " marginB-40 ";
            break;
        }
        case ("Top-40px,Bot-40px"): {
            marginMobile = " margin-40 ";
            break;
        }
        case ("Top-0px,Bot-0px"): {
            marginMobile = " margin-0-M ";
            break;
        }
        default: {
            marginMobile = " marginT-40 ";
            break;
        }
    }
    return [marginDesktop, marginMobile];
}

// htmlWidget Class Name,
// This class contains typography measurements as per designs
// This is used for those containers which are using dangerouslySetInnerHTML attribute 
// to render source code coming from HtmlWidget of OpenCMS
export const htmlWidget =  " htmlWidget " + (LargeBusiness.isLBSite ?  "LB ": "")

